module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "workplace-contact-us"
  }, [_c('h3', {
    staticClass: "text-center"
  }, [_vm._v("Contact us!")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.serverErrors),
      expression: "serverErrors"
    }],
    staticClass: "error-message text-center"
  }, [_vm._v("Unable to deliver message.")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.serverErrors && !_vm.showThankyou),
      expression: "!serverErrors && !showThankyou"
    }],
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.description))]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.serverErrors && _vm.showThankyou),
      expression: "!serverErrors && showThankyou"
    }],
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.thankyouMessage))]), _vm._v(" "), _c('div', {
    staticClass: "wwf-form light"
  }, [_c('div', {
    staticClass: "flip-wrapper",
    class: {
      'formValidation-shake': _vm.isShake
    }
  }, [_c('div', {
    staticClass: "form-grid"
  }, [_c('label', [_vm._v("First name"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.firstName),
      expression: "firstName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'border-red': _vm.errors.has('firstName')
    },
    attrs: {
      "name": "firstName",
      "type": "text"
    },
    domProps: {
      "value": (_vm.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.firstName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', [_vm._v("Last name"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lastName),
      expression: "lastName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'border-red': _vm.errors.has('lastName')
    },
    attrs: {
      "name": "lastName",
      "type": "text"
    },
    domProps: {
      "value": (_vm.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lastName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', [_vm._v("Email"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.emailAddress),
      expression: "emailAddress"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    class: {
      'border-red': _vm.errors.has('emailAddress')
    },
    attrs: {
      "name": "emailAddress",
      "type": "email"
    },
    domProps: {
      "value": (_vm.emailAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.emailAddress = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', [_vm._v("Phone\n            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    attrs: {
      "name": "phone",
      "type": "tel"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "span-fw"
  }, [_vm._v("Message"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'border-red': _vm.errors.has('message')
    },
    attrs: {
      "name": "message",
      "type": "text"
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('p', [_vm._v("Mandatory field(s) marked with *")]), _vm._v(" "), _c('input', {
    staticClass: "submit-btn",
    attrs: {
      "type": "button",
      "value": "Submit"
    },
    on: {
      "click": _vm.postTicket
    }
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ae921bd","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=2orvgp80z9y!./~/string-replace-webpack-plugin/loader.js?id=fk6phdenes7!./src/components/forms/WorkplaceContactUs.vue
// module id = 651
// module chunks = 0